var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.742,
    height: 12.363,
    viewBox: "0 0 15.742 12.363",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_53182",
    "data-name": "Group 53182",
    transform: "translate(-1037 -147.637)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(1036.98 147.637)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65542",
    "data-name": "Path 65542",
    d: "M14.215,12.363H1.567A1.49,1.49,0,0,1,.473,11.91,1.49,1.49,0,0,1,.02,10.816V1.535A1.471,1.471,0,0,1,.473.447,1.5,1.5,0,0,1,1.567,0H8.528L6.981,1.535H2.34a.737.737,0,0,0-.55.23.753.753,0,0,0-.224.544v7.735a.737.737,0,0,0,.23.55.753.753,0,0,0,.544.224h11.1a.764.764,0,0,0,.773-.773V1.994L15.762.85v9.967a1.547,1.547,0,0,1-1.547,1.547ZM3.887,6.756,5.628,8.5l-2.514.773ZM6.4,7.916,4.467,5.994l5.789-5.8a.716.716,0,0,1,.979,0l.955.967a.67.67,0,0,1,.2.477.648.648,0,0,1-.2.489Z",
    fill: "#8993ac"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_65544",
    "data-name": "Path 65544",
    d: "M15.191,5.466Zm0,0v0Zm0,2.452V6.45h-2.87L11.11,7.919Zm0,2.452h0Zm0,0v0Zm0-3.921Zm0-.984V4H14.005l-1.25,1.469Zm0,0v0Zm0,2.452v0Zm0,2.452V8.9H10.264L8.725,10.371Z",
    transform: "translate(1034.975 147.293)",
    fill: "#8993ac"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditReport);
export default __webpack_public_path__ + "static/media/editReport.334fbcb585707237e2b13a24ebd90547.svg";
export { ForwardRef as ReactComponent };